var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back",attrs:{"to":_vm.to}},[_c('i',{staticClass:"fas fa-chevron-left"}),_c('ruby',[_c('rb',[_vm._v("戻")]),_c('rt',[_vm._v("もどる")])],1),_vm._v("る")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609a6fed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/TBackButton.vue
// module id = null
// module chunks = 